import { DefaultTheme } from 'styled-components';
import {
  VisualIdentityTypes,
  VisualIdentityActionTypes,
  VisualIdentity
} from './visualIdentityTypes';

export function getVisualIdentity(): VisualIdentityActionTypes {
  return {
    type: VisualIdentityTypes.GET_VISUAL_IDENTITY
  };
}

export function saveVisualIdentity(
  colors: DefaultTheme | null,
  logoUrl: string | undefined,
  isError: boolean,
  errorMessages: string[] | null
): VisualIdentityActionTypes {
  return {
    type: VisualIdentityTypes.SAVE_VISUAL_IDENTITY,
    payload: { colors, logoUrl, isError, errorMessages }
  };
}

export function updateColors(
  colors: DefaultTheme
): VisualIdentityActionTypes {
  return {
    type: VisualIdentityTypes.UPDATE_COLORS,
    payload: { colors }
  };
}

export function updateLogoUrl(
  logoUrl?: string
): VisualIdentityActionTypes {
  return {
    type: VisualIdentityTypes.UPDATE_LOGO_URL,
    payload: { logoUrl }
  };
}

export function setVisualIdentity(
  visualIdentity: VisualIdentity
): VisualIdentityActionTypes {
  return {
    type: VisualIdentityTypes.SET_VISUAL_IDENTITY,
    payload: visualIdentity
  };
}

export function resetColors(): VisualIdentityActionTypes {
  return {
    type: VisualIdentityTypes.RESET_COLORS
  };
}

export function resetReducerVisualIdentity(): VisualIdentityActionTypes {
  return {
    type: VisualIdentityTypes.RESET_REDUCER_VISUAL_IDENTITY
  };
}
